export class AppConfig {

  App_Name = "Arena Fenster";
  App_Version = "1.0.0";

  baseURI = "http://test.lovanet.ch/arenafenster/app_controller/";
   
 
  constructor() {
  }
  
  steps = 10;
}
 


// WEBPACK FOOTER //
// ./src/app/app-config.ts